// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".r-date-range-label{margin-right:3.2rem}.r-date-range-button{white-space:nowrap}.r-date-range-preset-picker .r-popover{min-width:150px}.r-date-range-preset-picker .r-button-size-regular.r-has-icon{padding:var(--inset-s) var(--inset-xs);border-radius:0 var(--border-radius) var(--border-radius) 0}.r-date-range .r-button-type-default:focus{box-shadow:var(--button-default-box-shadow)}.r-range-picker-item{max-width:500px;white-space:nowrap;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
